import { AxiosError, AxiosResponse } from "axios";
import { IResponse, IServerError } from "../../../../models/common";

import { IConnectZoho } from "../../../../models/AddOns/Accounting/ZohoBooks/ConnectZoho";
import { IExportData } from "../../../../models/AddOns/Accounting/ExportData";
import http from "../../../../common/http-commons";

export const ZohoBooksService = {
	// ########################################### CONNECT ZOHO #########################################
	getPermissionConnectZoho: async (
		clientId: string,
		navigateToLogout: (path: string) => void,
	): Promise<IConnectZoho | IServerError | IResponse | null | any> => {
		if (!clientId) return null;
		try {
			const response: AxiosResponse<IConnectZoho> =
				await http.get<IConnectZoho>(`/v1/connect-zoho/${clientId}/`);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getConnectZoho: async (
		clientId: string,
		navigateToLogout: (path: string) => void,
	): Promise<IConnectZoho | IServerError | IResponse | null | any> => {
		if (!clientId) return null;
		try {
			const response: AxiosResponse<IConnectZoho> =
				await http.get<IConnectZoho>(`/v1/connect-zoho/${clientId}/`);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	create: async (
		requestPayload: any,
	): Promise<IConnectZoho | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IConnectZoho> =
				await http.post<IConnectZoho>(
					`/v1/connect-zoho/${requestPayload.clientId}`,
					requestPayload,
				);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delConnectZoho: async (
		delPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		const screenTag = delPayload.connectZohoPageName;
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/connect-zoho/${delPayload.clientId}/`,
				// delPayload.connectZohoId
			);

			if (response.status === 204) {
				return "connect Zoho has been deleted successfully";
			} else if (response.status === 200) {
				return "connect Zoho has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getConnectZohoDDL: async (
		clientId: string,
	): Promise<any | IServerError | IResponse | null> => {
		try {
			const response: AxiosResponse<any[]> = await http.get<any[]>(
				`/v1/connect-zoho/ddl?client_id=${clientId}`,
			);
			if (response.status === 200) {
				return response.data;
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch {}
	},

	getInvoiceDDL: async (
		clientId: string,
	): Promise<any | IServerError | IResponse | null> => {
		try {
			const response: AxiosResponse<any[]> = await http.get<any[]>(
				`/v1/connect-zoho/ddl?client_id=${clientId}`, // change later
			);
			if (response.status === 200) {
				return response.data;
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch {}
	},
};
